const isMobile = () => window.innerWidth < 931;

export default isMobile;
